// Common data for WW operations.
module.exports = {
  // Default language should be listed first.
  markets: {
    au: {
      en: {
        preD8: false,
        country: 'au',
        hreflang: 'en-AU',
        href: '/au/',
        locale: 'au',
        applangaLocale: 'en-AU',
        workshop: 'find-a-workshop',
        coaches: 'browse-coaches',
        coachesUrl: 'en_AU/coaches.html',
        recipe: 'recipe',
        meal: 'meal',
        blog: 'blog',
        author: 'authors',
        reviewer: 'reviewers',
        plans: 'plans',
        priceDetailsTemplate: 'A',
      },
    },
    be: {
      nl: {
        preD8: false,
        country: 'be',
        hreflang: 'nl-BE',
        href: '/be/nl/',
        locale: 'nb',
        applangaLocale: 'nl-BE',
        workshop: 'vind-een-workshop',
        recipe: 'recept',
        meal: 'maaltijd',
        blog: 'blog',
        author: 'auteurs',
        reviewer: 'beoordelaars',
        plans: 'prijzen',
        priceDetailsTemplate: 'B',
      },
      fr: {
        preD8: false,
        country: 'be',
        hreflang: 'fr-BE',
        href: '/be/fr/',
        locale: 'fb',
        applangaLocale: 'fr-BE',
        workshop: 'trouvez-un-atelier',
        recipe: 'recette',
        meal: 'repas',
        blog: 'blog',
        author: 'auteurs',
        reviewer: 'evaluateurs',
        plans: 'prix',
        priceDetailsTemplate: 'B',
      },
    },
    ca: {
      en: {
        preD8: false,
        country: 'ca',
        hreflang: 'en-CA',
        href: '/ca/en/',
        locale: 'ca',
        applangaLocale: 'en-CA',
        workshop: 'find-a-workshop',
        coaches: 'browse-coaches',
        coachesUrl: 'en_CA/coaches.html',
        recipe: 'recipe',
        meal: 'meal',
        blog: 'blog',
        author: 'authors',
        reviewer: 'reviewers',
        plans: 'plans',
        priceDetailsTemplate: 'A',
      },
      fr: {
        preD8: false,
        country: 'ca',
        hreflang: 'fr-CA',
        href: '/ca/fr/',
        locale: 'fc',
        applangaLocale: 'fr-CA',
        workshop: 'trouvez-un-atelier',
        coaches: 'choisir-son-coach',
        coachesUrl: 'fr_CA/coaches.html',
        recipe: 'recette',
        meal: 'repas',
        blog: 'blog',
        author: 'auteurs',
        reviewer: 'evaluateurs',
        plans: 'prix',
        priceDetailsTemplate: 'A',
      },
    },
    ch: {
      de: {
        preD8: false,
        country: 'ch',
        hreflang: 'de-CH',
        href: '/ch/de/',
        locale: 'ds',
        applangaLocale: 'de-CH',
        workshop: 'finde-einen-workshop',
        recipe: 'rezept',
        meal: 'mahlzeit',
        blog: 'blog',
        author: 'redaktion',
        reviewer: 'experten',
        plans: 'preise',
        priceDetailsTemplate: 'C',
      },
      fr: {
        preD8: false,
        country: 'ch',
        hreflang: 'fr-CH',
        href: '/ch/fr/',
        locale: 'fs',
        applangaLocale: 'fr-CH',
        workshop: 'trouvez-un-atelier',
        recipe: 'recette',
        meal: 'repas',
        blog: 'blog',
        author: 'redaction',
        reviewer: 'evaluateurs',
        plans: 'prix',
        priceDetailsTemplate: 'C',
      },
    },
    de: {
      de: {
        preD8: false,
        country: 'de',
        hreflang: 'de-DE',
        href: '/de/',
        locale: 'de',
        applangaLocale: 'de-DE',
        workshop: 'finde-einen-workshop',
        recipe: 'rezept',
        meal: 'mahlzeit',
        blog: 'blog',
        author: 'redaktion',
        reviewer: 'experten',
        plans: 'preise',
        priceDetailsTemplate: 'C',
      },
    },
    fr: {
      fr: {
        preD8: false,
        country: 'fr',
        hreflang: 'fr-FR',
        href: '/fr/',
        locale: 'fr',
        applangaLocale: 'fr-FR',
        workshop: 'trouvez-un-atelier',
        coaches: 'choisir-son-coach',
        coachesUrl: 'fr/coaches.html',
        recipe: 'recette',
        meal: 'menu',
        blog: 'blog',
        author: 'auteurs',
        reviewer: 'relecteurs',
        plans: 'prix',
        priceDetailsTemplate: 'B',
      },
    },
    nl: {
      nl: {
        preD8: false,
        country: 'nl',
        hreflang: 'nl-NL',
        href: '/nl/',
        locale: 'nl',
        applangaLocale: 'nl-NL',
        workshop: 'vind-een-workshop',
        recipe: 'recept',
        meal: 'maaltijd',
        blog: 'blog',
        author: 'auteurs',
        reviewer: 'beoordelaars',
        plans: 'prijzen',
        priceDetailsTemplate: 'A',
      },
    },
    nz: {
      en: {
        preD8: false,
        country: 'nz',
        hreflang: 'en-NZ',
        href: '/nz/',
        locale: 'nz',
        applangaLocale: 'en-NZ',
        workshop: 'find-a-workshop',
        coaches: 'browse-coaches',
        coachesUrl: 'en_AU/coaches.html',
        recipe: 'recipe',
        meal: 'meal',
        blog: 'blog',
        author: 'authors',
        reviewer: 'reviewers',
        plans: 'plans',
        priceDetailsTemplate: 'A',
      },
    },
    se: {
      sv: {
        preD8: false,
        country: 'se',
        hreflang: 'sv-SE',
        href: '/se/',
        locale: 'se',
        applangaLocale: 'sv',
        workshop: 'har-finns-vi',
        recipe: 'recept',
        meal: 'meny',
        blog: 'artikel',
        author: 'forfattare',
        reviewer: 'granskare',
        plans: 'medlemskap',
        priceDetailsTemplate: 'A',
      },
    },
    uk: {
      en: {
        preD8: false,
        country: 'uk',
        hreflang: 'en-GB',
        href: '/uk/',
        locale: 'uk',
        applangaLocale: 'en-GB',
        workshop: 'find-a-workshop',
        coaches: 'browse-coaches',
        coachesUrl: 'en_GB/coaches.html',
        recipe: 'recipe',
        meal: 'meal',
        blog: 'blog',
        author: 'authors',
        reviewer: 'reviewers',
        plans: 'plans',
        priceDetailsTemplate: 'A',
      },
    },
    us: {
      en: {
        preD8: false,
        country: 'us',
        hreflang: 'en-US',
        href: '/us/',
        locale: 'us',
        applangaLocale: 'en-US',
        workshop: 'find-a-workshop',
        coaches: 'browse-coaches',
        coachesUrl: 'coaches.html',
        recipe: 'recipe',
        meal: 'meal',
        blog: 'blog',
        author: 'authors',
        reviewer: 'reviewers',
        plans: 'plans',
        priceDetailsTemplate: 'A',
      },
    },
  },
  allowedQueryStringParameters: [
    // GQL domain override
    'env',
    // Preview mode.
    'sid',
    'vid',
    // Pagination.
    'page',
    // Pricing
    'blAdminUserId',
    'blSandboxId',
    'blAuthToken',
    'blSandboxDateTime',
    'cmp',
    'bg',
    'pz',
    'channelId',
    'sponsorId',
    'promotionId',
    'locationId',
  ],
};
